/* eslint-disable react/jsx-no-target-blank */
import React from 'react'
// import {useIntl} from 'react-intl'
// import {KTIcon} from '../../../../helpers'
import { toAbsoluteUrl } from '../../../../../_metronic/helpers'
import { SidebarMenuItemWithSub } from './SidebarMenuItemWithSub'
import { SidebarMenuItem } from './SidebarMenuItem'
import { useAuth } from '../../../../../app/modules/auth'

const SidebarMenuMain = () => {
  const URL_APP_ANDROID = process.env.URL_APP_ANDROID || 'https://play.google.com/store/apps/details?id=com.amsm.app&hl=en&gl=US'
  const URL_APP_IOS = process.env.URL_APP_IOS || 'https://apps.apple.com/cl/app/amsm/id1634475575?l=en'
  // const intl = useIntl()
  // const {auth} = useAuth();
  const { currentUser, auth } = useAuth();

  return (
    <>
      {auth && typeof auth.categoria === 'string' && auth.categoria === 'FIRMANTE' ? (
        <>
          <SidebarMenuItem
            to='/documentos'
            icon='document'
            title='Documentos'
            fontIcon='bi bi-phone-flip'
          />
          <div className='menu-item'>
            <div className='menu-content pt-8 pb-2'>
              <span className='menu-section text-muted text-uppercase fs-8 ls-1'>Opciones</span>
            </div>
          </div>
          <SidebarMenuItem
            to='/nosotros'
            icon='element-7'
            title='Nosotros'
            fontIcon='bi-app-indicator'
          />
        </>
      ) : (
        <>
          <SidebarMenuItem
            to='/inicio'
            icon='element-11'
            // title={intl.formatMessage({id: 'MENU.DASHBOARD'})}
            title='Inicio'
            fontIcon='bi-app-indicator'
          />
          {/* <SidebarMenuItem to='/builder' icon='switch' title='Layout Builder' fontIcon='bi-layers' /> */}
          <div className='menu-item'>
            <div className='menu-content pt-8 pb-2'>
              <span className='menu-section text-muted text-uppercase fs-8 ls-1'>Opciones</span>
            </div>
          </div>
          <SidebarMenuItemWithSub
            to='/crafted/pages'
            title='Pagos'
            fontIcon='bi-archive'
            icon='element-plus'
          >
            {/* <SidebarMenuItemWithSub to='/crafted/pages/profile' title='Profile' hasBullet={true}>
          <SidebarMenuItem to='/crafted/pages/profile/overview' title='Overview' hasBullet={true} />
          <SidebarMenuItem to='/crafted/pages/profile/projects' title='Projects' hasBullet={true} />
          <SidebarMenuItem
            to='/crafted/pages/profile/campaigns'
            title='Campaigns'
            hasBullet={true}
          />
          <SidebarMenuItem
            to='/crafted/pages/profile/documents'
            title='Documents'
            hasBullet={true}
          />
          <SidebarMenuItem
            to='/crafted/pages/profile/connections'
            title='Connections'
            hasBullet={true}
          />
        </SidebarMenuItemWithSub> */}

            {/* <SidebarMenuItemWithSub to='/crafted/pages/wizards' title='Wizards' hasBullet={true}> */}
            <SidebarMenuItem
              to='/pagos/monto-no-retirado'
              title='Pagos por retirar'
              hasBullet={true}
            />
            <SidebarMenuItem to='/pagos/detalle' title='Detalle de Liquidaciones' hasBullet={true} />
            {/* </SidebarMenuItemWithSub> */}
          </SidebarMenuItemWithSub>
          <SidebarMenuItemWithSub
            to='/crafted/accounts'
            title='Cuentas'
            icon='profile-circle'
            fontIcon='bi-person'
          >
            <SidebarMenuItem to='/detalle-cuenta' title='Detalles' hasBullet={true} />
            <SidebarMenuItem to='/resumen-cuentas' title='Resumen Trimestral' hasBullet={true} />
            <SidebarMenuItem to='/resumen-anual' title='Resumen Anual' hasBullet={true} />
            <SidebarMenuItem to='/equipo/medico' title='Equipo Médico' hasBullet={true} />
            <SidebarMenuItem to='/visits' title='Registro de Visitas Lyra' hasBullet={true} />
          </SidebarMenuItemWithSub>
          {/* <SidebarMenuItemWithSub to='/error' title='Errors' fontIcon='bi-sticky' icon='cross-circle'>
        <SidebarMenuItem to='/error/404' title='Error 404' hasBullet={true} />
        <SidebarMenuItem to='/error/500' title='Error 500' hasBullet={true} />
      </SidebarMenuItemWithSub>
      <SidebarMenuItemWithSub
        to='/crafted/widgets'
        title='Widgets'
        icon='element-7'
        fontIcon='bi-layers'
      >
        <SidebarMenuItem to='/crafted/widgets/lists' title='Lists' hasBullet={true} />
        <SidebarMenuItem to='/crafted/widgets/statistics' title='Statistics' hasBullet={true} />
        <SidebarMenuItem to='/crafted/widgets/charts' title='Charts' hasBullet={true} />
        <SidebarMenuItem to='/crafted/widgets/mixed' title='Mixed' hasBullet={true} />
        <SidebarMenuItem to='/crafted/widgets/tables' title='Tables' hasBullet={true} />
        <SidebarMenuItem to='/crafted/widgets/feeds' title='Feeds' hasBullet={true} />
      </SidebarMenuItemWithSub> */}

          {/* <SidebarMenuItem
        to='/facturas'
        icon='element-11'
        title='Facturas'
        fontIcon='bi-app-indicator'
      /> */}

          <SidebarMenuItem
            to='/aranceles'
            icon='tag'
            title='Aranceles'
            fontIcon='bi bi-phone-flip'
          />

          <SidebarMenuItem
            to='/documentos'
            icon='document'
            title='Documentos'
            fontIcon='bi bi-phone-flip'
          />

          <SidebarMenuItem
            to='/buzonpam'
            icon='element-9'
            title='Buzón PAM'
            fontIcon='bi-app-indicator'
          />

          {/* <SidebarMenuItem
        to='/contactenos'
        icon='messages'
        title='Contáctenos'
        fontIcon='bi-app-indicator'
      /> */}

          <SidebarMenuItem
            to='/nosotros'
            icon='element-7'
            title='Nosotros'
            fontIcon='bi-app-indicator'
          />

          {/* {auth?.profesionalAsociado && <SidebarMenuItem
        to='/convenios'
        icon='element-6'
        title='Convenios'
        fontIcon='bi-app-indicator'
      />} */}

          {/* <SidebarMenuItem
            to='/marketplace'
            icon='handcart'
            title='Marketplace'
            fontIcon='bi-app-indicator'
          /> */}

          <SidebarMenuItem
            to='/logout'
            icon='exit-right'
            title='Cerrar sesión'
            fontIcon='bi-app-indicator'
          />

          <div className='menu-item'>
            <div className='menu-content pt-8 pb-2'>
              <span className='menu-section text-muted text-uppercase fs-8 ls-1'>Apps</span>
            </div>
          </div>

          <div style={{ paddingLeft: '15px' }}>
            <p className='text-white'>Descarga nuestra app</p>
            <a href={URL_APP_IOS}>
              <img
                src={toAbsoluteUrl('/media/svg/brand-logos/apple-store-badge.svg')}
                alt=''
              />
            </a>
          </div>
          <div style={{ paddingLeft: '15px', marginTop: '20px' }}>
            <a href={URL_APP_ANDROID}>
              <img
                src={toAbsoluteUrl('/media/svg/brand-logos/google-play-badge.svg')}
                alt=''
              />
            </a>
          </div>

          {/* <SidebarMenuItemWithSub
        to='/apps/chat'
        title='Chat'
        fontIcon='bi-chat-left'
        icon='message-text-2'
      >
        <SidebarMenuItem to='/apps/chat/private-chat' title='Private Chat' hasBullet={true} />
        <SidebarMenuItem to='/apps/chat/group-chat' title='Group Chart' hasBullet={true} />
        <SidebarMenuItem to='/apps/chat/drawer-chat' title='Drawer Chart' hasBullet={true} />
      </SidebarMenuItemWithSub>
      <SidebarMenuItem
        to='/apps/user-management/users'
        icon='abstract-28'
        title='User management'
        fontIcon='bi-layers'
      />
      <div className='menu-item'>
        <a
          target='_blank'
          className='menu-link'
          href={process.env.REACT_APP_PREVIEW_DOCS_URL + '/docs/changelog'}
        >
          <span className='menu-icon'>
            <KTIcon iconName='code' className='fs-2' />
          </span>
          <span className='menu-title'>Changelog {process.env.REACT_APP_VERSION}</span>
        </a>
      </div> */}
        </>
      )}
    </>
  )
}

export { SidebarMenuMain }
